export * from './lib/sidenav.service.module';

export { AccredibleSidenavConfig } from './lib/models/sidenav.model';
export { SidenavRef } from './lib/sidenav-ref';
export { AccredibleSidenavService, SIDENAV_DATA } from './lib/sidenav.service';
